"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuBannerKitNatal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const _mld_multimarcas_1 = require("../../../../@mld-multimarcas");
const utils_1 = require("../../../../utils");
const MenuBannerKitNatal = ({ catalogSlug, isVdf }) => {
    const { isBannerOn, isLoading } = (0, _mld_multimarcas_1.useKitExperimentBanner)({ type: 'home' });
    const isMobile = (0, flora_react_1.useIsMobile)();
    if (!isMobile) {
        return null;
    }
    const isMultibrand = utils_1.envConfig.currentBrand === utils_1.CurrentBrandEnv.MLT;
    const notShouldRenderBrand = utils_1.envConfig.currentBrand === utils_1.CurrentBrandEnv.EAM || isMultibrand;
    if (notShouldRenderBrand) {
        return null;
    }
    if ((0, utils_1.isGenericReseller)(catalogSlug) || !isVdf) {
        return null;
    }
    if (!isBannerOn || isLoading) {
        return null;
    }
    const params = new URLSearchParams({
        origin: utils_1.envConfig.currentBrand,
        utm_source: utils_1.envConfig.currentBrand,
        utm_medium: 'banner-natal',
    });
    const url = `${utils_1.envConfig.multibrandUrl}/${catalogSlug}?${params.toString()}`;
    return ((0, jsx_runtime_1.jsx)(flora_react_1.Box, Object.assign({ css: {
            display: 'grid',
            gridTemplateColumns: '4fr',
            marginBottom: '$2',
        } }, { children: (0, jsx_runtime_1.jsx)(flora_react_1.Box, Object.assign({ css: { width: '100vw', height: '46px', img: { width: '100%' } } }, { children: (0, jsx_runtime_1.jsx)(_mld_multimarcas_1.MenuBanner, { catalogUrl: url, type: "home" }) })) })));
};
exports.MenuBannerKitNatal = MenuBannerKitNatal;
